<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >  
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Counter Parties</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    fixed-header
    :headers="headers"
    :items="confirmedCounterParties ? allCounterparties : allCounterparties.filter(a => a.CheckerID === 0)"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <!-- the rejection dialog  -->
      <v-dialog persistent v-model="rejectionDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">ok</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- the delete dialog  -->
      <v-dialog persistent v-model="deleteDialog" max-width="350px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">yes</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

      <v-form flat color="#ffffff00" v-if="create">
        <v-stepper v-model="e1">
          <v-stepper-header class="elevation-0">
            <v-stepper-step
              :rules="[() => step1_valid]"
              :complete="e1 > 1"
              step="1"
            >
              Contact Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :rules="[() => step2_valid]"
              :complete="e1 > 2"
              step="2"
            >
              Categories
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :rules="[() => step3_valid]"
              :complete="e1 > 3"
              step="3"
            >
              Limits
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="step_1" v-model="step1_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col class="pb-0">
                    <v-card class="pa-5 pt-2">
                      <span class="caption">Physical Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Physical_Address_1"
                        required
                        :readonly="view"
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Physical_Address_2"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Physical_Address_3"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="counter_party.Physical_CityID"
                        :items="allCities.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>
                  <v-col class="pb-0">
                    <v-card v-if="SyncAddress == false" class="pa-5 pt-2">
                      <span class="caption">Postal Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Postal_Address_1"
                        required
                        :readonly="view"
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Postal_Address_2"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Postal_Address_3"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="counter_party.Postal_CityID"
                        :items="allCities.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>

                    <v-card v-else class="pa-5 pt-2">
                      <span class="caption">Postal Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Physical_Address_1"
                        required
                        :readonly="view"
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Physical_Address_2"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="counter_party.Physical_Address_3"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="counter_party.Physical_CityID"
                        :items="allCities.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>
                  <v-col class="pb-0">
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="counter_party.CounterPartyCode"
                      label="Code"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 10) || 'field must be less than 10 characters'
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="counter_party.CounterPartyName"
                      label="Name"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 50) || 'field must be less than 50 characters'
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="counter_party.Email"
                      label="Email"
                      required
                      :rules="emailRules"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="counter_party.Telephone"
                      label="Telephone"
                      required
                      type="number"
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 30) || 'field must be less than 30 characters'
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="counter_party.Fax"
                      label="Fax"
                      type="number"
                      required
                      :rules="[
                        v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="counter_party.ContactName"
                      label="ContactName"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 50) || 'field must be less than 50 characters'
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ml-1 mr-1">
                  <v-col cols="8">
                    <div class="text-center">
                      <v-btn @click="syncPostalAddress()" block outlined rounded color="#2A353D" class="pr-3" v-on="on">
                        Make Postal address the same as the Physical address<v-icon class="ml-1">mdi-cached</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" @click="validateStep_1()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
                </span>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-form ref="step_2" v-model="step2_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col>
                    <v-checkbox
                      v-model="counter_party.IsBroker"
                      class="mt-0"
                      label="Is Stock Broker?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="counter_party.IsTransferSecretary"
                      class="mt-0"
                      label="Is Transfer Secretary?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="counter_party.IsIssuer"
                      class="mt-0"
                      label="Is Issuer?"
                      :readonly="view"
                    ></v-checkbox>
                  </v-col>

                  <v-col>
                    <v-checkbox
                      v-model="counter_party.IsBuyer"
                      class="mt-0"
                      label="Is Buyer?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="counter_party.IsSeller"
                      class="mt-0"
                      label="Is Seller?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="counter_party.IsPromoter"
                      class="mt-0"
                      label="Is Promoter?"
                      :readonly="view"
                    ></v-checkbox>
                  </v-col>

                  <v-col>
                    <v-checkbox
                      v-model="counter_party.IsPropertyManager"
                      class="mt-0"
                      label="Is Property Manager?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="counter_party.IsPropertyTrustee"
                      class="mt-0"
                      label="Is Property Trustee?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="counter_party.IsPropertyHolder"
                      class="mt-0"
                      label="Is Property Holder?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="counter_party.IsBank"
                      class="mt-0"
                      label="Is Bank?"
                      :readonly="view"
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn @click="e1 = 1" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" @click="validateStep_2()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
                </span>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-form ref="step_3" v-model="step3_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="counter_party.LimitDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="counter_party.LimitDate"
                        label="Limit Date"
                        append-icon="mdi-calendar-month"
                        readonly
                        dense filled color="#2A353D"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                      </template>
                      <v-date-picker color="#2A353D" v-model="counter_party.LimitDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
                      <v-btn outlined small color="#2A353D" @click="$refs.menu.save(counter_party.LimitDate)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="counter_party.Limit"
                      label="Limit"
                      type="number"
                      :readonly="view"
                      required
                      :rules="TextFieldRules"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn @click="e1 = 2" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
                  <v-btn class="white--text ml-4" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>
                </span>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

      <v-form flat color="#ffffff00" v-if="edit">
        <span class="d-flex flex-row my-2">
          <v-spacer/>
          <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCounterParty.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span v-if="currentCounterParty.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCounterParty.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCounterParty.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        </span>

        <v-stepper v-model="e1">
          <v-stepper-header class="elevation-0">
            <v-stepper-step
              :rules="[() => step1_valid]"
              :complete="e1 > 1"
              step="1"
            >
              Contact Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :rules="[() => step2_valid]"
              :complete="e1 > 2"
              step="2"
            >
              Categories
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :rules="[() => step3_valid]"
              :complete="e1 > 3"
              step="3"
            >
              Limits
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="step_1" v-model="step1_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col class="pb-0">
                    <v-card class="pa-5 pt-2">
                      <span class="caption">Physical Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Physical_Address_1"
                        required
                        :readonly="view"
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Physical_Address_2"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Physical_Address_3"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="currentCounterParty.Physical_CityID"
                        :items="allCities.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>
                  <v-col class="pb-0">
                    <v-card v-if="SyncAddress == false" class="pa-5 pt-2">
                      <span class="caption">Postal Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Postal_Address_1"
                        required
                        :readonly="view"
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Postal_Address_2"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Postal_Address_3"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="currentCounterParty.Postal_CityID"
                        :items="allCities.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>

                    <v-card v-else class="pa-5 pt-2">
                      <span class="caption">Postal Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Physical_Address_1"
                        required
                        :readonly="view"
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Physical_Address_2"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCounterParty.Physical_Address_3"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="currentCounterParty.Physical_CityID"
                        :items="allCities.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>
                  <v-col class="pb-0">
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentCounterParty.CounterPartyCode"
                      label="Code"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 10) || 'field must be less than 10 characters'
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentCounterParty.CounterPartyName"
                      label="Name"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 50) || 'field must be less than 50 characters'
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentCounterParty.Email"
                      label="Email"
                      required
                      :rules="emailRules"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentCounterParty.Telephone"
                      label="Telephone"
                      required
                      type="number"
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 30) || 'field must be less than 30 characters'
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentCounterParty.Fax"
                      label="Fax"
                      type="number"
                      required
                      :rules="[
                        v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentCounterParty.ContactName"
                      label="ContactName"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 50) || 'field must be less than 50 characters'
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ml-1 mr-1">
                  <v-col cols="8">
                    <div class="text-center">
                      <v-btn @click="syncPostalAddress()" block outlined rounded color="#2A353D" class="pr-3" v-on="on">
                        Make Postal address the same as the Physical address<v-icon class="ml-1">mdi-cached</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" @click="validateStep_1()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
                </span>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-form ref="step_2" v-model="step2_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col>
                    <v-checkbox
                      v-model="currentCounterParty.IsBroker"
                      class="mt-0"
                      label="Is Stock Broker?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="currentCounterParty.IsTransferSecretary"
                      class="mt-0"
                      label="Is Transfer Secretary?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="currentCounterParty.IsIssuer"
                      class="mt-0"
                      label="Is Issuer?"
                      :readonly="view"
                    ></v-checkbox>
                  </v-col>

                  <v-col>
                    <v-checkbox
                      v-model="currentCounterParty.IsBuyer"
                      class="mt-0"
                      label="Is Buyer?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="currentCounterParty.IsSeller"
                      class="mt-0"
                      label="Is Seller?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="currentCounterParty.IsPromoter"
                      class="mt-0"
                      label="Is Promoter?"
                      :readonly="view"
                    ></v-checkbox>
                  </v-col>

                  <v-col>
                    <v-checkbox
                      v-model="currentCounterParty.IsPropertyManager"
                      class="mt-0"
                      label="Is Property Manager?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="currentCounterParty.IsPropertyTrustee"
                      class="mt-0"
                      label="Is Property Trustee?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="currentCounterParty.IsPropertyHolder"
                      class="mt-0"
                      label="Is Property Holder?"
                      :readonly="view"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="currentCounterParty.IsBank"
                      class="mt-0"
                      label="Is Bank?"
                      :readonly="view"
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn @click="e1 = 1" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" @click="validateStep_2()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
                </span>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-form ref="step_3" v-model="step3_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="currentCounterParty.LimitDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="currentCounterParty.LimitDate"
                        label="Limit Date"
                        append-icon="mdi-calendar-month"
                        readonly
                        dense filled color="#2A353D"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                      </template>
                      <v-date-picker color="#2A353D" v-model="currentCounterParty.LimitDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
                      <v-btn outlined small color="#2A353D" @click="$refs.menu.save(currentCounterParty.LimitDate)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="currentCounterParty.Limit"
                      label="Limit"
                      type="number"
                      :readonly="view"
                      required
                      :rules="TextFieldRules"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn @click="e1 = 2" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
                  <v-btn class="white--text ml-4" v-if="!view" small color="#2A353D" @click="update()">save</v-btn>
                </span>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>

      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-show="confirmedCounterParties" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedAccountStatuses" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu> -->
        <v-btn @click="generatePDF(true)" v-if="confirmedCounterParties" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedCounterParties" @click="confirmedCounterParties = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedCounterParties && item.CheckerID == 0" top>

        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveCounterParty(item, index); updateStatus()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedCounterParties && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveCounterParty(item, index); rejectionDialog = true"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedCounterParties"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveCounterParty(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        :disabled="edit"
        @click="view = true; setActiveCounterParty(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-icon
        :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
        color="#2A353D" @click="setActiveCounterParty(item, index); deleteDialog = true"
      >
       mdi-trash-can-outline
      </v-icon>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template> 

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  name: 'counter_parties',

  data () {
    return {
      e1: 1,
      confirmedCounterParties: true,
      edit: false,
      view: false,
      create:false,
      rejectionDialog: false,
      deleteDialog: false,
      SyncAddress: false,
      permitted: null,
      permitted_dialog: true,
      RejectionStatus: 0,
      message: '',
      search: '',
      step1_valid: true,
      step2_valid: true,
      step3_valid: true,
      content: '',
      currentCounterParty: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Code',
          align: 'start',
          sortable: true,
          value: 'CounterPartyCode'
        },
        { text: 'Counterparty Name', value: 'CounterPartyName', sortable: false },
        // { text: 'Telephone', value: 'Telephone', sortable: false },
        // { text: 'Email', value: 'Email', sortable: false },
        // { text: 'Fax', value: 'Fax', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        v => (v && v.length <= 100) || 'field must be less than 100 characters'
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      counter_party: {},
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allAccountStatuses",
      "allRejectionReasons",
      "allUsers",
      "allCounterparties",
      "allCountries",
      "allCities",
      "allConfirmationSettings"
    ]),

    valid() {
      if (this.step1_valid == true && this.step2_valid == true && this.step3_valid == true){
        return true
      } else {
        return false
      }
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 304).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },  

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 304).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 304).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 304).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 304).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createCounterParty",
      "updateCounterParty",
      "deleteCounterParty",
    ]),

    async createNew() {
      this.message = '';
      await this.validateStep_3();
      if (this.step3_valid == true) {
        if(this.SyncAddress == true){
          this.counter_party.Postal_Address_1 = this.counter_party.Physical_Address_1;
          this.counter_party.Postal_Address_2 = this.counter_party.Physical_Address_2;
          this.counter_party.Postal_Address_3 = this.counter_party.Physical_Address_3;
          this.counter_party.Postal_CityID = this.counter_party.Physical_CityID
        }
        this.counter_party.MakerID = this.currentUser.SecurityUserID,
        this.counter_party.CheckerID = this.CheckerID,
        this.counter_party.LastUserID = this.currentUser.SecurityUserID,
        this.createCounterParty(this.counter_party)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newCounterParty',
            data: response.data
          });
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    async update() {
      this.message = '';
      await this.validateStep_3();
      if (this.step3_valid == true) {
        if(this.SyncAddress == true){
          this.currentCounterParty.Postal_Address_1 = this.currentCounterParty.Physical_Address_1;
          this.currentCounterParty.Postal_Address_2 = this.currentCounterParty.Physical_Address_2;
          this.currentCounterParty.Postal_Address_3 = this.currentCounterParty.Physical_Address_3;
          this.currentCounterParty.Postal_CityID = this.currentCounterParty.Physical_CityID
        }
        if(this.currentCounterParty.CheckerID == 0){
          this.currentCounterParty.LastUserID = this.currentUser.SecurityUserID,
          this.currentCounterParty.RejectionID = this.RejectionStatus,
          this.currentCounterParty.CheckerID = 0,
          this.currentCounterParty.CheckDate = null,

          this.updateCounterParty(this.currentCounterParty)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updCounterParty',
              data: this.currentCounterParty
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        } else {
          this.currentCounterParty.MakerID = this.currentUser.SecurityUserID
          this.currentCounterParty.LastUserID = this.currentUser.SecurityUserID,
          this.currentCounterParty.RejectionID = this.RejectionStatus,
          this.currentCounterParty.CheckerID = 0,
          this.currentCounterParty.CheckDate = null,
          this.currentCounterParty.MakeDate = new Date(),

          this.updateCounterParty(this.currentCounterParty)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updCounterParty',
              data: this.currentCounterParty
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        }
      }
    },

    deleteItem() {
      this.message = '';
      this.deleteCounterParty(this.currentCounterParty)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltCounterParty',
          data: this.currentCounterParty
        });
        
        this.message = response.data.message
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    updateStatus() {
      this.message = '';

      this.currentCounterParty.CheckerID = this.currentUser.SecurityUserID,
      this.currentCounterParty.LastUserID = this.currentUser.SecurityUserID,
      this.currentCounterParty.RejectionID = this.RejectionStatus,
      this.currentCounterParty.CheckDate = new Date(),
      this.currentCounterParty.updatedAt = new Date(),

      this.updateCounterParty(this.currentCounterParty)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updCounterParty',
          data: this.currentCounterParty
        });
        
        this.message = response.data.message
        this.RejectionStatus = 0;
        this.rejectionDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        // to close the dialog 
         this.RejectionStatus = 0;
        this.rejectionDialog = false

      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Counterparties", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Counterparties.pdf')
      }
    },

    syncPostalAddress () {
      this.SyncAddress = !this.SyncAddress
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedCounterParties = false
    },

    showEdit () {
      this.e1 = 1;
      this.edit = true
    },

    closeEdit() {
      this.SyncAddress = false;
      this.edit = false
    },

    showCreate () {
      this.e1 = 1;
      this.create = true
    },

    closeCreate() {
      this.counter_party = {};
      this.SyncAddress = false;
      this.create = false
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    async validateStep_1(){
      await this.$refs.step_1.validate()
        if(this.step1_valid == true){
          this.e1 = 2
        }
      return this.step1_valid
    },

    async validateStep_2(){
      await this.$refs.step_2.validate()
        if(this.step2_valid == true){
          this.e1 = 3
        }
      return this.step2_valid
    },

    async validateStep_3(){
      await this.$refs.step_3.validate()
        if(this.step3_valid == true){
          this.e1 = 4
        }
      return this.step3_valid
    },

    reset () {
      this.$refs.step_1.reset(),
      this.$refs.step_2.reset(),
      this.$refs.step_3.reset(),

      this.valid = true
    },

    setActiveCounterParty (item, index) {
      this.currentCounterParty = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isCounterParties().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedCounterParties", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
